export default __webpack_public_path__ + "static/life_science-4f84a54a6de1a0f363aa6ac459122fa2.png";